// extracted by mini-css-extract-plugin
module.exports = {"wrap":"yp-z","heading":"zp-z","items":"Ap-z","featureCss":"Bp-z","disabled":"Cp-z","imgCss":"Dp-z"};